import {loadingGraphData} from '#/components/graphs/loading-graph-data';
import {FunctionComponent, ReactElement} from 'react';
import {Line, LineChart, ResponsiveContainer, XAxis, YAxis} from 'recharts';

export const DateValueLineGraph = <Data,>(props: {
  data: ({date: number} & Data)[];
  isLoading: boolean;
  yDataKey: keyof Data;
}): ReactElement => {
  const {data, isLoading, yDataKey} = props;

  const isStable = !isLoading && data.every((entry, _, array) => entry[yDataKey] === array[0][yDataKey]);

  const getGraphColor = () => {
    if (isLoading) return 'gray';
    else if (isStable) return '#6374C3';
    else if (data.length > 0 && data[data.length - 1][yDataKey] >= data[0][yDataKey]) return '#23DB6C';
    else return '#FF5252';
  };
  const graphColor = getGraphColor();
  const gradientUrlKey = `${graphColor}-gradient`;
  const graphMargin = 1;

  return (
    <ResponsiveContainer width='100%' height='100%' style={{position: 'unset'}}>
      <LineChart
        data={isLoading ? loadingGraphData : data}
        className={`pointer-events-none ${isLoading ? 'animate-pulse' : ''} m-0`}
        margin={{
          top: graphMargin,
          right: graphMargin,
          left: graphMargin,
          bottom: graphMargin,
        }}
      >
        <defs>
          <linearGradient id={gradientUrlKey} x1='0' y1='0' x2='0' y2='1'>
            <stop offset='5%' stopColor={graphColor} stopOpacity={0.8} />
            <stop offset='99%' stopColor={graphColor} stopOpacity={0.1} />
          </linearGradient>
        </defs>

        <XAxis dataKey={'date'} scale='time' type='number' domain={['dataMin', 'dataMax']} hide={true} />
        <YAxis domain={['dataMin', 'dataMax']} hide={true} />

        <Line
          type='linear'
          dataKey={isLoading ? 'test' : (yDataKey as string)}
          stroke={graphColor}
          strokeWidth={2}
          isAnimationActive={false}
          dot={false}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export const DateValueLineGraphLoadingSmall: FunctionComponent = () => (
  <svg viewBox='0 0 112 48' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M0 36.72c4.4-4.679 13.2-23.373 22-23.395 8.8-.021 13.2 24.927 22 23.286 8.8-1.64 13.2-29.436 22-31.487 8.8-2.05 13.2 16.998 22 21.235 8.8 4.238 17.6-.038 22-.047'
      fill='none'
      stroke='#9ca3af'
      strokeWidth='2'
    />
  </svg>
);

export const DateValueLineGraphLoadingLarge: FunctionComponent = () => (
  <svg viewBox='0 0 140 48' xmlns='http://www.w3.org/2000/svg'>
    <path
      d='M0 31.441c5.6-.615 16.8 1.8 28-3.077C39.2 23.488 44.8 8.73 56 7.06 67.2 5.389 72.8 19.847 84 20.01c11.2.164 16.8-12.952 28-12.132 11.2.82 22.4 12.985 28 16.232'
      fill='none'
      stroke='#9ca3af'
      strokeWidth='2'
    />
  </svg>
);
